import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * 文字数制限チェッククラス
 */
export default class EFOcats_validate_limit extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    if (
      checkData.attr('data-minlength') !== undefined &&
      checkData.attr('data-maxlength') !== undefined &&
      (checkData.attr('data-minlength') > checkData.val().length || checkData.attr('data-maxlength') < checkData.val().length)
    ) {
      this.obj_remove(checkData.parents('.inner').find('.attention-text'));
      return new EFOcats_error_info(
        'error',
        this.langagerList('以上以内', {datamaxlength: checkData.attr('data-maxlength'), dataminlength: checkData.attr('data-minlength')}),
        '',
        '以上以内'
      );
    }
    if (checkData.attr('data-minlength') !== undefined && checkData.attr('data-minlength') > checkData.val().length) {
      this.obj_remove(checkData.parents('.inner').find('.attention-text'));
      return new EFOcats_error_info('error', this.langagerList('以上', {dataminlength: checkData.attr('data-minlength')}), '', '以上');
    }
    if (checkData.attr('data-maxlength') !== undefined && checkData.attr('data-maxlength') < checkData.val().length) {
      this.obj_remove(checkData.parents('.inner').find('.attention-text'));
      return new EFOcats_error_info('error', this.langagerList('以内', {datamaxlength: checkData.attr('data-maxlength')}), '', '以内');
    }

    return new EFOcats_error_info('success', '', '', '');
  }

  obj_remove(obj) {
    obj.addClass('hidden');
  }
}
